import uiRouter from 'angular-ui-router';
import foodBenefitRoutingComponent from './foodBenefitRouting.component';
import foodBenefitRoutingService from './foodBenefitRouting.service';
import { ROUTES } from 'common/domain/routes';
import { STATES } from 'common/domain/states';

let foodBenefitRoutingModule = angular.module('food-benefit.routing', [
  uiRouter,
])

  .config(($stateProvider) => {
    'ngInject';

    $stateProvider
      .state(STATES.FOOD_BENEFIT.ROOT, {
        abstract: true,
        parent: STATES.MAIN_ROUTING,
        url: ROUTES.FOOD_BENEFIT.ROOT,
        component: 'foodBenefitRouting',
        data: {
          requiresAuth: true,
        },
        resolve: {
          /* @ngInject */
          moduleClosed: (StatusAppCheckers) => StatusAppCheckers.getClosedModules()
        }
      });
  })

  .component('foodBenefitRouting', foodBenefitRoutingComponent)

  .service('foodBenefitRoutingService', foodBenefitRoutingService)

  .name;

export default foodBenefitRoutingModule;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/features/foodBenefitRouting/foodBenefitRouting.js